import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './app/store';
import { Provider } from 'react-redux';
import MOCK_COMMENTS from './assets/comments.js'

if (!localStorage.getItem('comments')) localStorage.setItem('comments', JSON.stringify(MOCK_COMMENTS))

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

